/**
 * Created with Mei Zhiwei on 2018-08-01 11:33:19.
 * Description: 厂商类型
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: meizhiwei@meituan.com
 * @Last Modified time: 2018-08-06 20:13:28
 */
export const vendorTypes = {
  10: '连锁',
  20: '零售'
};



// WEBPACK FOOTER //
// ./src/config/vendorTypes.js